"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _times = _interopRequireDefault(require("lodash/times"));

var _generateUuid = _interopRequireDefault(require("../../utils/generate-uuid"));

var _Row = _interopRequireDefault(require("../Row"));

var _default = {
  type: "FourCol",
  description: "Four columns in a single row",
  label: "Four Column Row",
  generateContent: function generateContent() {
    return [{
      id: (0, _generateUuid["default"])(),
      type: "Row",
      content: (0, _times["default"])(4, function () {
        return {
          id: (0, _generateUuid["default"])(),
          type: "Row",
          content: [],
          attrs: _Row["default"].defaultAttrs({
            width: "".concat(100 / 4, "%"),
            allowChildren: true
          })
        };
      }),
      attrs: _Row["default"].defaultAttrs({
        direction: "horizontal",
        allowChildren: false
      })
    }];
  }
};
exports["default"] = _default;